export enum TypeNotification {
    Email = 'email',
    Push = 'push',
}
export enum TypeCategoryNotifications {
    GeopoliticalConflicts = 'geop',
    InternalSocialTensions = 'ist',
    PotentialInsecurity = 'pi',
    ClimateEnvironmental = 'clr',
    MedicalRisk = 'mdr',
    LGBT = 'lgbtq',
    FemaleTravel = 'fem',
    BordersEntry = 'entry',
    TransportUpdates = 'transp',
}
